import GoogleMapsDefaultParser from '../../src/parsers/GoogleMapsParser'

export default GoogleMapsDefaultParser
